import Menu from '@/global/components/MenuV2'
import { FormField } from 'global/components/Form'
import { useEffect, useState } from 'react'
import { FuncoesAvaliacao, funcoesAvaliacao } from 'service/api'

interface IProps {
    required?: boolean
}

export function SelectFunction({ required }: IProps) {
    const [funcoes, setFuncoes] = useState<FuncoesAvaliacao[]>([])

    useEffect(() => {
        funcoesAvaliacao.get().then(res => {
            setFuncoes(res)
        })
    }, [])

    return (
        <FormField required={required} name="funcaoId" select label="Função">
            {funcoes.map((funcao, id) => (
                <Menu.Item key={id} value={funcao.id}>
                    {funcao.nome}
                </Menu.Item>
            ))}
        </FormField>
    )
}
